






import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class GreyPanel extends Vue {
    @Prop({ type: Boolean, default: false }) readonly big!: boolean
    @Prop({ type: Boolean, default: false }) readonly noMargin!: boolean

    get componentClass() {
        return {
            'grey-panel': true,
            'grey-panel--big': this.big,
            'grey-panel--no-margin': this.noMargin,
        }
    }
}


